'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*
  This proxy helps us detect when a component is reading a translationKey that
  it forgot to request. All new translation keys should get added here.

  Original context: https://github.com/narvar/nth/pull/1119#discussion_r971075156
*/

const translationKeys = {
  blockDeliveryStatusEtaFormattedTime: 1,
  blockDeliveryStatusEtaText: 1,
  blockDeliveryStatusFormattedTime: 1,
  blockDeliveryStatusHideHistory: 1,
  blockDeliveryStatusHistoryTitle: 1,
  blockDeliveryStatusShowHistory: 1,
  blockEddAriaLabelLastDayDateFormat: 1,
  blockEddAriaLabelLastWeekDateFormat: 1,
  blockEddAriaLabelNextDayDateFormat: 1,
  blockEddAriaLabelNextWeekDateFormat: 1,
  blockEddAriaLabelSameDayDateFormat: 1,
  blockEddAriaLabelSameElseDateFormat: 1,
  blockEddBottomLastDayDateFormat: 1,
  blockEddBottomLastWeekDateFormat: 1,
  blockEddBottomNextDayDateFormat: 1,
  blockEddBottomNextWeekDateFormat: 1,
  blockEddBottomSameDayDateFormat: 1,
  blockEddBottomSameElseDateFormat: 1,
  blockEddMiddleLastDayDateFormat: 1,
  blockEddMiddleLastWeekDateFormat: 1,
  blockEddMiddleNextDayDateFormat: 1,
  blockEddMiddleNextWeekDateFormat: 1,
  blockEddMiddleSameDayDateFormat: 1,
  blockEddMiddleSameElseDateFormat: 1,
  blockEddTopLastDayDateFormat: 1,
  blockEddTopLastWeekDateFormat: 1,
  blockEddTopNextDayDateFormat: 1,
  blockEddTopNextWeekDateFormat: 1,
  blockEddTopSameDayDateFormat: 1,
  blockEddTopSameElseDateFormat: 1,
  blockEddDateTokenOrder: 1,
  blockEddDayOfMonthLastDayDateFormat: 1,
  blockEddDayOfMonthLastWeekDateFormat: 1,
  blockEddDayOfMonthNextDayDateFormat: 1,
  blockEddDayOfMonthNextWeekDateFormat: 1,
  blockEddDayOfMonthSameDayDateFormat: 1,
  blockEddDayOfMonthSameElseDateFormat: 1,
  blockEddDayOfWeekLastDayDateFormat: 1,
  blockEddDayOfWeekLastWeekDateFormat: 1,
  blockEddDayOfWeekNextDayDateFormat: 1,
  blockEddDayOfWeekNextWeekDateFormat: 1,
  blockEddDayOfWeekSameDayDateFormat: 1,
  blockEddDayOfWeekSameElseDateFormat: 1,
  blockEddDayOfWeekShortLastDayDateFormat: 1,
  blockEddDayOfWeekShortLastWeekDateFormat: 1,
  blockEddDayOfWeekShortNextDayDateFormat: 1,
  blockEddDayOfWeekShortNextWeekDateFormat: 1,
  blockEddDayOfWeekShortSameDayDateFormat: 1,
  blockEddDayOfWeekShortSameElseDateFormat: 1,
  blockEddMonthLastDayDateFormat: 1,
  blockEddMonthLastWeekDateFormat: 1,
  blockEddMonthNextDayDateFormat: 1,
  blockEddMonthNextWeekDateFormat: 1,
  blockEddMonthSameDayDateFormat: 1,
  blockEddMonthSameElseDateFormat: 1,
  blockSelectDefaultLabel: 1,
  blockSelectDefaultNoOptions: 1,
  conciergeCancelButtonText: 1,
  conciergeDeliveryOptionPudoDescription: 1,
  conciergeDeliveryOptionPudoTitle: 1,
  conciergeDeliveryOptionTitle: 1,
  conciergeDeliveryOptionToAddressDescription: 1,
  conciergeDeliveryOptionToAddressTitle: 1,
  conciergeFetchLocationsFailedMessage: 1,
  conciergeNoStoreFoundMessage: 1,
  conciergePaymentMethodContent: 1,
  conciergePaymentMethodSubmitLabel: 1,
  conciergePaymentPickupLabel: 1,
  conciergeSearchLocationBtnText: 1,
  conciergeSearchLocationNearText: 1,
  conciergeShippingMethodSubmitLabel: 1,
  conciergeShowLocationNearText: 1,
  countryDropdownAriaLabel: 1,
  deliveryInstructionsInitialHeaderText: 1,
  deliveryInstructionsInitialSubheaderText: 1,
  deliveryInstructionsInitialButtonText: 1,
  deliveryInstructionsStep1Text: 1,
  deliveryInstructionsStep2Text: 1,
  deliveryInstructionsVerifyAddressHeader: 1,
  deliveryInstructionsVerifyAddressDescription: 1,
  deliveryInstructionsFirstName: 1,
  deliveryInstructionsLastName: 1,
  deliveryInstructionsAddressLine1: 1,
  deliveryInstructionsAddressLine2: 1,
  deliveryInstructionsAddressPlaceholder: 1,
  deliveryInstructionsCity: 1,
  deliveryInstructionsState: 1,
  deliveryInstructionsPostalCode: 1,
  deliveryInstructionsCountry: 1,
  deliveryInstructionsVerifyButtonText: 1,
  deliveryInstructionsCancelButtonText: 1,
  deliveryInstructionsVerifyErrorText: 1,
  deliveryInstructionsLeaveInstructionsHeader: 1,
  deliveryInstructionsLeaveInstructionsSubheader: 1,
  deliveryInstructionsDeliveryOptionsLabel: 1,
  deliveryInstructionsDeliveryOptionsPlaceholder: 1,
  deliveryInstructionsCodeLabel1: 1,
  deliveryInstructionsCodeLabel2: 1,
  deliveryInstructionsCodePlaceholder1: 1,
  deliveryInstructionsCodePlaceholder2: 1,
  deliveryInstructionsEmailAddress: 1,
  deliveryInstructionsPhoneNumber: 1,
  deliveryInstructionsCheckboxDisclaimer: 1,
  deliveryInstructionsSubmitInstructionsButtonText: 1,
  deliveryInstructionsProvidedByText: 1,
  deliveryInstructionsRequiredFieldErrorText: 1,
  deliveryInstructionsEnterCodeErrorText: 1,
  deliveryInstructionsSubmitSuccessText: 1,
  deliveryInstructionsSubmitMyChoiceSuccessText: 1,
  deliveryInstructionsProvidedByLasershipText: 1,
  deliveryInstructionsSystemError: 1,
  deliveryInstructionsLeaveAtLabel: 1,
  deliveryInstructionsLeaveAtFrontDoorLabel: 1,
  deliveryInstructionsLeaveAtSideDoorLabel: 1,
  deliveryInstructionsLeaveAtRearDoorLabel: 1,
  deliveryInstructionsLeaveAtGarageLabel: 1,
  deliveryInstructionsLeaveAtReceptionLabel: 1,
  deliveryInstructionsLeaveAtOtherLabel: 1,
  deliveryInstructionsAdditionalNotesLabel: 1,
  driverDetailsCallButtonText: 1,
  driverDetailsChatButtonText: 1,
  driverDetailsDriverChangeText: 1,
  eddCalculatorCutoffCountdownTemplate: 1,
  eddCalculatorPostalCodeInputErrorMessage: 1,
  eddCalculatorPostalCodeInputLabel: 1,
  eddCalculatorPostalCodeInputSubmitText: 1,
  eddCalculatorPostalCodeInputTemplate: 1,
  eddCalculatorPostalCodeInputToggleTextTemplate: 1,
  eddCalculatorShippingMethodInfo1Carrier: 1,
  eddCalculatorShippingMethodInfo1ServiceCode: 1,
  eddCalculatorShippingMethodInfo1ServiceDisplayName: 1,
  eddCalculatorShippingMethodInfo1Template: 1,
  eddCalculatorShippingMethodInfo2Carrier: 1,
  eddCalculatorShippingMethodInfo2ServiceCode: 1,
  eddCalculatorShippingMethodInfo2ServiceDisplayName: 1,
  eddCalculatorShippingMethodInfo2Template: 1,
  eddCalculatorShippingMethodsInfoDefaultTemplate: 1,
  externalLinkAriaLabel: 1,
  feedbackButtonText: 1,
  feedbackButtonTextShort: 1,
  feedbackChangeStarRating: 1,
  feedbackCommentLabel: 1,
  feedbackCustomerSupportLink: 1,
  feedbackExperienceBodyText: 1,
  feedbackExperienceHeader: 1,
  feedbackPanelTitleText: 1,
  feedbackRatingShortFive: 1,
  feedbackRatingShortFour: 1,
  feedbackRatingShortOne: 1,
  feedbackRatingShortThree: 1,
  feedbackRatingShortTwo: 1,
  feedbackRatingSubcaption: 1,
  feedbackSuccessBodyText: 1,
  feedbackSuccessHeaderText: 1,
  footerPrivacyLinkText: 1,
  footerPrivacyLink: 1,
  getEddCartLastDayDateFormat: 1,
  getEddCartLastWeekDateFormat: 1,
  getEddCartNextDayDateFormat: 1,
  getEddCartNextWeekDateFormat: 1,
  getEddCartSameDayDateFormat: 1,
  getEddCartSameElseDateFormat: 1,
  getEddCheckoutLastDayDateFormat: 1,
  getEddCheckoutLastWeekDateFormat: 1,
  getEddCheckoutNextDayDateFormat: 1,
  getEddCheckoutNextWeekDateFormat: 1,
  getEddCheckoutSameDayDateFormat: 1,
  getEddCheckoutSameElseDateFormat: 1,
  getEddDefaultLastDayDateFormat: 1,
  getEddDefaultLastWeekDateFormat: 1,
  getEddDefaultNextDayDateFormat: 1,
  getEddDefaultNextWeekDateFormat: 1,
  getEddDefaultSameDayDateFormat: 1,
  getEddDefaultSameElseDateFormat: 1,
  getEddOrderConfirmationLastDayDateFormat: 1,
  getEddOrderConfirmationLastWeekDateFormat: 1,
  getEddOrderConfirmationNextDayDateFormat: 1,
  getEddOrderConfirmationNextWeekDateFormat: 1,
  getEddOrderConfirmationSameDayDateFormat: 1,
  getEddOrderConfirmationSameElseDateFormat: 1,
  getEddOrderDetailsLastDayDateFormat: 1,
  getEddOrderDetailsLastWeekDateFormat: 1,
  getEddOrderDetailsNextDayDateFormat: 1,
  getEddOrderDetailsNextWeekDateFormat: 1,
  getEddOrderDetailsSameDayDateFormat: 1,
  getEddOrderDetailsSameElseDateFormat: 1,
  getEddOrderHistoryLastDayDateFormat: 1,
  getEddOrderHistoryLastWeekDateFormat: 1,
  getEddOrderHistoryNextDayDateFormat: 1,
  getEddOrderHistoryNextWeekDateFormat: 1,
  getEddOrderHistorySameDayDateFormat: 1,
  getEddOrderHistorySameElseDateFormat: 1,
  getEddProductDetailsLastDayDateFormat: 1,
  getEddProductDetailsLastWeekDateFormat: 1,
  getEddProductDetailsNextDayDateFormat: 1,
  getEddProductDetailsNextWeekDateFormat: 1,
  getEddProductDetailsSameDayDateFormat: 1,
  getEddProductDetailsSameElseDateFormat: 1,
  giftTrackingBannerMessage: 1,
  giftTrackingBannerLink: 1,
  giftTrackingRecipientMessage: 1,
  giftTrackingSharingMessageBody: 1,
  giftTrackingSharingMessageSubject: 1,
  giftTrackingSendEmailPrompt: 1,
  giftTrackingSendEmailButtonText: 1,
  giftTrackingCopyLinkPrompt: 1,
  giftTrackingCopyLinkButtonText: 1,
  giftTrackingCopyLinkSuccessMessage: 1,
  helpPillText: 1,
  itemsInShipmentPanelTitle: 1,
  itemsInShipmentItemTitle: 1,
  itemsInShipmentAttribute0: 1,
  itemsInShipmentAttribute1: 1,
  itemsInShipmentAttribute2: 1,
  itemsInShipmentAttribute3: 1,
  locationGetDirections: 1,
  locationHoursOpenUntil: 1,
  locationHoursOpenFuture: 1,
  locationMoreInfo: 1,
  locationNotFoundDescription: 1,
  locationNotFoundHeader: 1,
  locationPanelTitle: 1,
  locationSeeStoreHours: 1,
  locationHideStoreHours: 1,
  moreInformationTitle: 1,
  moreInformationText: 1,
  moreInformationLink: 1,
  moreInformationHeader: 1,
  notificationCenterMarketingOptInText: 1,
  notificationCenterApiErrorHeader: 1,
  notificationCenterApiErrorMessage: 1,
  notificationCenterSmsApiErrorHeader: 1,
  notificationCenterSmsApiErrorMessage: 1,
  notificationCenterPanelTitleText: 1,
  notificationCenterAppPushPanelTitleText: 1,
  notificationCenterSmsPanelTitleText: 1,
  notificationCenterSmsContinueShopping: 1,
  notificationCenterSmsDisclaimerText: 1,
  notificationCenterSmsDisclaimerTextMarketing: 1,
  notificationCenterSmsDisclaimerLinkLabel: 1,
  notificationCenterSmsInputLabel: 1,
  notificationCenterSmsOptinMessage: 1,
  notificationCenterSmsOptoutLink: 1,
  notificationCenterSmsSignupAgain: 1,
  notificationCenterSmsSignupButton: 1,
  notificationCenterSmsUnsubscribedMessage: 1,
  notificationCenterSmsUpdateNumberButton: 1,
  notificationCenterSmsUpdateNumberMessage: 1,
  notificationCenterValidationErrorMessage: 1,
  notificationCenterSmsValidationErrorMessage: 1,
  notificationCenterSublimeAutoOptinText: 1,
  notificationCenterSublimeAutoOptinTitle: 1,
  notificationCenterSublimeDisclaimerCopy: 1,
  notificationCenterSublimeErrorMessage: 1,
  notificationCenterSublimeManageYourPreferences: 1,
  notificationCenterSublimeOptin: 1,
  notificationCenterSublimeSignUpForUpdates: 1,
  notificationCenterSublimeUnsubscribeFromAll: 1,
  notificationCenterSublimeUnsubscribeText: 1,
  notificationCenterSublimeUnsubscribeTitle: 1,
  notificationCenterEmailApiErrorHeader: 1,
  notificationCenterEmailApiErrorMessage: 1,
  notificationCenterEmailPanelTitleText: 1,
  notificationCenterEmailContinueShopping: 1,
  notificationCenterEmailDisclaimerLinkLabel: 1,
  notificationCenterEmailDisclaimerText: 1,
  notificationCenterEmailInputLabel: 1,
  notificationCenterEmailOptinMessage: 1,
  notificationCenterEmailOptoutLink: 1,
  notificationCenterEmailSignupAgain: 1,
  notificationCenterEmailSignupButton: 1,
  notificationCenterEmailUnsubscribedMessage: 1,
  notificationCenterEmailUpdateButton: 1,
  notificationCenterEmailUpdateMessage: 1,
  notificationCenterEmailValidationErrorMessage: 1,
  notificationCenterAppPushUpdateMessage: 1,
  notificationCenterRetailerLevelSubscribeOption: 1,
  notificationCenterSmsUpdateNumberMessageRetailerLevel: 1,
  notificationCenterSmsOptoutLinkRetailerLevel: 1,
  notificationCenterEmailUpdateMessageRetailerLevel: 1,
  notificationCenterEmailOptoutLinkRetailerLevel: 1,
  notificationCenterSmsUnsubscribedMessageRetailerLevel: 1,
  notificationCenterEmailUnsubscribedMessageRetailerLevel: 1,
  notificationCenterRetailerLevelSubscribeUpsellPrompt: 1,
  notificationCenterRetailerLevelSubscribeUpsellAction: 1,
  notificationCenterSmsDisclaimerTextRetailerLevel: 1,
  notificationCenterEmailDisclaimerTextRetailerLevel: 1,
  notificationCenterLineApiErrorHeader: 1,
  notificationCenterLineApiErrorMessage: 1,
  notificationCenterLineContinueShopping: 1,
  notificationCenterLinePanelTitleText: 1,
  notificationCenterLineLoginButtonText: 1,
  notificationCenterLineRegistrationError: 1,
  notificationCenterLineOptinMessage: 1,
  notificationCenterLineOptoutLink: 1,
  notificationCenterLineOptoutLinkRetailerLevel: 1,
  notificationCenterLineSignupAgain: 1,
  notificationCenterLineTryAgain: 1,
  notificationCenterLineUnsubscribedMessage: 1,
  notificationCenterLineUnsubscribedMessageRetailerLevel: 1,
  notificationCenterLineUpdateMessage: 1,
  notificationCenterLineUpdateMessageRetailerLevel: 1,
  notificationCenterLineDisclaimerLinkLabel: 1,
  notificationCenterLineDisclaimerText: 1,
  notificationCenterLineDisclaimerTextRetailerLevel: 1,
  packEddPanelFallbackMessage: 1,
  packEddPanelProofOfDelivery: 1,
  packEddPanelProofOfDeliveryContractImage: 1,
  packEddPanelProofOfDeliveryExpandImage: 1,
  packEddPanelTitleText: 1,
  productRecommendationsIframeTitle: 1,
  productRecommendationsCarouselTitle: 1,
  shipmentsButton: 1,
  shipmentsItemLabel: 1,
  shipmentsPanelHeader: 1,
  shipmentsShipmentLabel: 1,
  packShipmentsAriaLabelLastDayDateFormat: 1,
  packShipmentsAriaLabelLastWeekDateFormat: 1,
  packShipmentsAriaLabelNextDayDateFormat: 1,
  packShipmentsAriaLabelNextWeekDateFormat: 1,
  packShipmentsAriaLabelSameDayDateFormat: 1,
  packShipmentsAriaLabelSameElseDateFormat: 1,
  packShipmentsLastDayDateFormat: 1,
  packShipmentsLastWeekDateFormat: 1,
  packShipmentsNextDayDateFormat: 1,
  packShipmentsNextWeekDateFormat: 1,
  packShipmentsSameDayDateFormat: 1,
  packShipmentsSameElseDateFormat: 1,
  packShipmentsDateTokenOrder: 1,
  packShipmentsDayOfWeekLastDayDateFormat: 1,
  packShipmentsDayOfWeekLastWeekDateFormat: 1,
  packShipmentsDayOfWeekNextDayDateFormat: 1,
  packShipmentsDayOfWeekNextWeekDateFormat: 1,
  packShipmentsDayOfWeekSameDayDateFormat: 1,
  packShipmentsDayOfWeekSameElseDateFormat: 1,
  packShipmentsDayOfMonthLastDayDateFormat: 1,
  packShipmentsDayOfMonthLastWeekDateFormat: 1,
  packShipmentsDayOfMonthNextDayDateFormat: 1,
  packShipmentsDayOfMonthNextWeekDateFormat: 1,
  packShipmentsDayOfMonthWeekSameDayDateFormat: 1,
  packShipmentsDayOfMonthSameElseDateFormat: 1,
  packShipmentsMonthLastDayDateFormat: 1,
  packShipmentsMonthLastWeekDateFormat: 1,
  packShipmentsMonthNextDayDateFormat: 1,
  packShipmentsMonthNextWeekDateFormat: 1,
  packShipmentsMonthSameDayDateFormat: 1,
  packShipmentsMonthSameElseDateFormat: 1,
  packShipmentsMoreDetails: 1,
  packShipmentsHideDetails: 1,
  pickupLocationHideDetails: 1,
  pickupLocationShowDetails: 1,
  pickupLocationInstructions: 1,
  shippingActivityGenericHeaderText: 1,
  shippingActivityHideFullHistoryButtonText: 1,
  shippingActivityLastDayDateFormat: 1,
  shippingActivityLastDayTimeFormat: 1,
  shippingActivityLastWeekDateFormat: 1,
  shippingActivityLastWeekTimeFormat: 1,
  shippingActivityLatestUpdateText: 1,
  shippingActivityNextDayDateFormat: 1,
  shippingActivityNextDayTimeFormat: 1,
  shippingActivityNextWeekDateFormat: 1,
  shippingActivityNextWeekTimeFormat: 1,
  shippingActivitySameDayDateFormat: 1,
  shippingActivitySameDayTimeFormat: 1,
  shippingActivitySameElseDateFormat: 1,
  shippingActivitySameElseTimeFormat: 1,
  shippingActivityShowFullHistoryButtonText: 1,
  shippingActivityTrackingNumberText: 1,
  shippingActivityViewCarrierTrackingDetails: 1,
  shopifyCheckoutOrderConfirmationLastDayDateFormat: 1,
  shopifyCheckoutOrderConfirmationLastWeekDateFormat: 1,
  shopifyCheckoutOrderConfirmationNextDayDateFormat: 1,
  shopifyCheckoutOrderConfirmationNextWeekDateFormat: 1,
  shopifyCheckoutOrderConfirmationSameDayDateFormat: 1,
  shopifyCheckoutOrderConfirmationSameElseDateFormat: 1,
  shopifyCheckoutOrderConfirmationTitle: 1,
  shopifyCheckoutShippingMethodLastDayDateFormat: 1,
  shopifyCheckoutShippingMethodLastWeekDateFormat: 1,
  shopifyCheckoutShippingMethodNextDayDateFormat: 1,
  shopifyCheckoutShippingMethodNextWeekDateFormat: 1,
  shopifyCheckoutShippingMethodPrefixText: 1,
  shopifyCheckoutShippingMethodSameDayDateFormat: 1,
  shopifyCheckoutShippingMethodSameElseDateFormat: 1,
  skipToContent: 1,
  trackPageTitle: 1,
  trackingStatus: 1,
  trackingStatusHelperText: 1,
  trackingStatusNoEddSubtext: 1,
  trackingStatusNoEddTitle: 1,
  returnsNoLocations: 1,
  returnsNoMethods: 1,
  returnsErrLocations: 1,
  returnsMiAway: 1,
  returnsKmAway: 1,
  returnsSearchLocations: 1,
  returnsShowMoreLocations: 1,
  returnsShowLessLocations: 1,
  returnsPostalCode: 1,
  returnsInvalidPostalCode: 1,
  returnsSearchButton: 1,
  returnsCancelButton: 1,
  returnsPickupLocationsNear: 1,
  returnsDropoffLocationsNear: 1,
  returnsSortBy: 1,
  returnsSortByRecommended: 1,
  returnsSortByDistance: 1,
  returnsMethodsHeading: 1,
  returnsReviewButtonLabel: 1,
  returnsSummaryEditButtonLabel: 1,
  returnsSummaryLocationHeading: 1,
  returnsFreeLabel: 1,
  returnsErrReturnsUnknown: 1,
  returnsErrReturnsBadRequest: 1,
  trackingStatusPreshipment0: 1,
  trackingStatusDelivered: 1,
  trackingStatusDeliveredNoEddSubtext: 1,
  trackingStatusDeliveredNoEddTitle: 1,
  trackingStatusDeliveryScheduled: 1,
  trackingStatusException: 1,
  trackingStatusExceptionNoEddSubtext: 1,
  trackingStatusExceptionNoEddTitle: 1,
  trackingStatusIntransit: 1,
  trackingStatusIntransitNoEddSubtext: 1,
  trackingStatusIntransitNoEddTitle: 1,
  trackingStatusJustshipped: 1,
  trackingStatusJustshippedNoEddSubtext: 1,
  trackingStatusJustshippedNoEddTitle: 1,
  trackingStatusReadytogo: 1,
  trackingStatusReadytogoNoEddSubtext: 1,
  trackingStatusReadytogoNoEddTitle: 1,
  trackingStatusScheduleDelivery: 1,
  redirectToHoldCta: 1,
  redirectToHoldRedirectPackage: 1,
  redirectToHoldAddressLine1: 1,
  redirectToHoldAddressLine2: 1,
  redirectToHoldPostalCode: 1,
  redirectToHoldStep1: 1,
  redirectToHoldVerifyAddressHeader: 1,
  redirectToHoldVerifyAddressDescription: 1,
  redirectToHoldCancel: 1,
  redirectToHoldVerify: 1,
  redirectToHoldVerifyError: 1,
  redirectToHoldIneligibleError: 1,
  redirectToHoldRequiredFieldError: 1,
  redirectToHoldSystemError: 1,
  redirectToHoldStep2: 1,
  redirectToHoldSelectLocationHeader: 1,
  redirectToHoldLocationsNearbyTemplate: 1,
  redirectToHoldErrorMissingAddress: 1,
  redirectToHoldBestEffortWarning: 1,
  redirectToHoldShowLess: 1,
  redirectToHoldShowMore: 1,
  redirectToHoldSelectLocation: 1,
  redirectToHoldConfirmPickup: 1,
  redirectToHoldChangeLocation: 1,
  redirectToHoldStep3: 1,
  redirectToHoldConfirmLocationHeader: 1,
  redirectToHoldConfirmLocationDescription: 1,
  redirectToHoldErrorMissingLocation: 1,
  redirectToHoldSuccessHeader: 1,
  redirectToHoldPickupInstructionsHeader: 1,
  redirectToHoldPickupInstructionsDescription: 1,
  redirectToHoldSuccessDeliveryManagerHeading: 1,
  redirectToHoldSuccessDeliveryManagerDescription: 1,
  redirectToHoldSuccessDeliveryManagerLink: 1,
  redirectToHoldPostSuccessHeader: 1,
  redirectToHoldLinkShowPickupDetails: 1,
  redirectToHoldLinkHidePickupDetails: 1,
  redirectToHoldPostSuccessPickupInstructionsHeader: 1,
  redirectToHoldPostSuccessPickupInstructionsDescription: 1,
  redirectToHoldPostSuccessPickupInstructionsLink: 1,
  redirectToHoldLinkDirections: 1,
  redirectToHoldErrorMissingRedirectedLocation: 1,
  redirectToHoldDayPrefix: 1,
  redirectToHoldOpenNow: 1,
  redirectToHoldOpenTomorrow: 1,
  redirectToHoldOpenPrefix: 1,
  redirectToHoldClosePrefix: 1,
  redirectToHoldOpenToday: 1,
  redirectToHoldStoreIsClosed: 1,
  redirectToHoldMonday: 1,
  redirectToHoldTuesday: 1,
  redirectToHoldWednesday: 1,
  redirectToHoldThursday: 1,
  redirectToHoldFriday: 1,
  redirectToHoldSaturday: 1,
  redirectToHoldSunday: 1,
  redirectToHoldClosedAllDay: 1,
  redirectToHoldOpenAllDay: 1,
  deliveryMapRefreshText: 1,
  claimsAdditionalInfoCommentsHelperTextOptionalWrongItem: 1,
  claimsAdditionalInfoCommentsHelperTextOptionalItemMissing: 1,
  claimsAdditionalInfoCommentsHelperTextOptionalItemDamaged: 1,
  claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing: 1,
  claimsAdditionalInfoCommentsHelperTextOptional: 1,
  claimsAdditionalInfoCommentsHelperTextRequiredWrongItem: 1,
  claimsAdditionalInfoCommentsHelperTextRequiredItemMissing: 1,
  claimsAdditionalInfoCommentsHelperTextRequiredItemDamaged: 1,
  claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing: 1,
  claimsAdditionalInfoCommentsHelperTextRequired: 1,
  claimsAdditionalInfoCommentsLabelWrongItem: 1,
  claimsAdditionalInfoCommentsLabelItemMissing: 1,
  claimsAdditionalInfoCommentsLabelItemDamaged: 1,
  claimsAdditionalInfoCommentsLabelPackageMissing: 1,
  claimsAdditionalInfoConfirmationLabelWrongItem: 1,
  claimsAdditionalInfoConfirmationLabelItemDamaged: 1,
  claimsAdditionalInfoConfirmationLabelItemMissing: 1,
  claimsAdditionalInfoConfirmationLabelPackageMissing: 1,
  claimsAdditionalInfoTitle: 1,
  claimsAdditionalInfoTitleLine2: 1,
  claimsAgentCanOverrideMessage: 1,
  claimsButtonBack: 1,
  claimsButtonNext: 1,
  claimsButtonBackToClaimsOverview: 1,
  claimsClaimTypeItemDamaged: 1,
  claimsClaimTypeItemMissing: 1,
  claimsClaimTypePackageMissing: 1,
  claimsClaimTypeWrongItem: 1,
  claimsChipComment: 1,
  claimsChipPhoto: 1,
  claimsChipQuantity: 1,
  claimsChipDetailedReason: 1,
  claimsChipCommentIconAccessibleTextComplete: 1,
  claimsChipCommentIconAccessibleTextIncomplete: 1,
  claimsChipPhotoIconAccessibleTextComplete: 1,
  claimsChipPhotoIconAccessibleTextIncomplete: 1,
  claimsChipQuantityIconAccessibleTextComplete: 1,
  claimsChipQuantityIconAccessibleTextIncomplete: 1,
  claimsChipDetailedReasonIconAccessibleTextComplete: 1,
  claimsChipDetailedReasonIconAccessibleTextIncomplete: 1,
  claimsClaimDetailsClaimStatusCreated: 1,
  claimsClaimDetailsClaimStatusPending: 1,
  claimsClaimDetailsClaimStatusInReview: 1,
  claimsClaimDetailsClaimStatusApproved: 1,
  claimsClaimDetailsClaimStatusDenied: 1,
  claimsClaimDetailsClaimStatusCanceled: 1,
  claimsClaimDetailsCreated: 1,
  claimsClaimDetailsItemsCount: 1,
  claimsClaimDetailsLabelClaimType: 1,
  claimsClaimDetailsLabelClaimReason: 1,
  claimsClaimDetailsLabelClaimAmount: 1,
  claimsClaimDetailsLabelCustomerComments: 1,
  claimsClaimDetailsLabelRulesMatched: 1,
  claimsClaimDetailsLabelIntelligence: 1,
  claimsClaimDetailsLastUpdated: 1,
  claimsClaimDetailsLastUpdatedLastDayDateFormat: 1,
  claimsClaimDetailsLastUpdatedLastWeekDateFormat: 1,
  claimsClaimDetailsLastUpdatedNextDayDateFormat: 1,
  claimsClaimDetailsLastUpdatedNextWeekDateFormat: 1,
  claimsClaimDetailsLastUpdatedSameDayDateFormat: 1,
  claimsClaimDetailsLastUpdatedSameElseDateFormat: 1,
  claimsClaimDetailsLoading: 1,
  claimsClaimDetailsBackToOrder: 1,
  claimsClaimDetailsBackToOrderIconText: 1,
  claimsClaimIdLabel: 1,
  claimsClaimDetailsReviewTitle: 1,
  claimsClaimDetailsReviewDetailsOutcome: 1,
  claimsClaimDetailsReviewDetailsReviewer: 1,
  claimsClaimDetailsReviewDetailsClosed: 1,
  claimsClaimDetailsResolvedOnLastDayDateFormat: 1,
  claimsClaimDetailsResolvedOnLastWeekDateFormat: 1,
  claimsClaimDetailsResolvedOnNextDayDateFormat: 1,
  claimsClaimDetailsResolvedOnNextWeekDateFormat: 1,
  claimsClaimDetailsResolvedOnSameDayDateFormat: 1,
  claimsClaimDetailsResolvedOnSameElseDateFormat: 1,
  claimsClaimDetailsReviewOptionApprove: 1,
  claimsClaimDetailsReviewOptionDeny: 1,
  claimsClaimDetailsReviewOptionCancel: 1,
  claimsClaimDetailsReviewOptionReview: 1,
  claimsClaimDetailsReviewReasonForOverride: 1,
  claimsClaimDetailsReviewRecommendedAction: 1,
  claimsClaimDetailsReviewRecommendedActionAccepted: 1,
  claimsClaimDetailsReviewSubmitLoading: 1,
  claimsClaimDetailsReviewSubmitError: 1,
  claimsClaimDetailsReviewSubmitSuccess: 1,
  claimsClaimDetailsReviewSubmit: 1,
  claimsClaimDetailsReviewActionReasonRequest: 1,
  claimsClaimDetailsReviewActionReasonRequestDropdownLabel: 1,
  claimsClaimDetailsReviewActionReasonRequestOtherLabel: 1,
  claimsClaimDetailsShipmentsLabelEstimatedDelivery: 1,
  claimsClaimDetailsShipmentsLabelPackage: 1,
  claimsClaimDetailsShipmentsTitle: 1,
  claimsClaimDetailsShipmentsItems: 1,
  claimsClaimDetailsShipmentsItemsHideContent: 1,
  claimsClaimDetailsShipmentsItemsShowContent: 1,
  claimsClaimDetailsShipmentsShippingActivity: 1,
  claimsClaimDetailsShipmentsShippingActivityHideContent: 1,
  claimsClaimDetailsShipmentsShippingActivityShowContent: 1,
  claimsClaimDetailsShippingActivityLastDayDateFormat: 1,
  claimsClaimDetailsShippingActivityLastDayTimeFormat: 1,
  claimsClaimDetailsShippingActivityLastWeekDateFormat: 1,
  claimsClaimDetailsShippingActivityLastWeekTimeFormat: 1,
  claimsClaimDetailsShippingActivityNextDayDateFormat: 1,
  claimsClaimDetailsShippingActivityNextDayTimeFormat: 1,
  claimsClaimDetailsShippingActivityNextWeekDateFormat: 1,
  claimsClaimDetailsShippingActivityNextWeekTimeFormat: 1,
  claimsClaimDetailsShippingActivitySameDayDateFormat: 1,
  claimsClaimDetailsShippingActivitySameDayTimeFormat: 1,
  claimsClaimDetailsShippingActivitySameElseDateFormat: 1,
  claimsClaimDetailsShippingActivitySameElseTimeFormat: 1,
  claimsClaimDetailsShipmentsCurrentStatusLabel: 1,
  claimsClaimDetailsShipmentsCarrierLink: 1,
  claimsClaimDetailsShipmentsEddLabel: 1,
  claimsClaimDetailsShipmentsEddLine1LastDayDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine1LastWeekDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine1NextDayDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine1NextWeekDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine1SameDayDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine1SameElseDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine2LastDayDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine2LastWeekDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine2NextDayDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine2NextWeekDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine2SameDayDateFormat: 1,
  claimsClaimDetailsShipmentsEddLine2SameElseDateFormat: 1,
  claimsClaimDetailsCustomerTitle: 1,
  claimsClaimDetailsCustomerLabelEmail: 1,
  claimsClaimDetailsCustomerLabelPhone: 1,
  claimsClaimDetailsCustomerLabelBillingAddress: 1,
  claimsClaimDetailsCustomerLabelShippingAddress: 1,
  claimsCreateClaimDismiss: 1,
  claimsDetailViewDismissStepItem: 1,
  claimsDetailViewDismissStepPackage: 1,
  claimsDetailedReasonTitle: 1,
  claimsDetailedReasonTitleLine2: 1,
  claimsDetailedReasonDropdownLabelWrongItem: 1,
  claimsDetailedReasonDropdownLabelItemDamaged: 1,
  claimsDetailedReasonDropdownLabelItemMissing: 1,
  claimsDetailedReasonDropdownLabelPackageMissing: 1,
  claimsDetailedReasonOtherReasonLabelWrongItem: 1,
  claimsDetailedReasonOtherReasonLabelItemDamaged: 1,
  claimsDetailedReasonOtherReasonLabelItemMissing: 1,
  claimsDetailedReasonOtherReasonLabelPackageMissing: 1,
  claimsDetailedReasonOtherReasonHelperTextWrongItem: 1,
  claimsDetailedReasonOtherReasonHelperTextItemDamaged: 1,
  claimsDetailedReasonOtherReasonHelperTextItemMissing: 1,
  claimsDetailedReasonOtherReasonHelperTextPackageMissing: 1,
  claimsIneligibilityItemPackageBeingReturned: 1,
  claimsIneligibilityItemMaxClaimed: 1,
  claimsIneligibilityItemClaimed: 1,
  claimsIneligibilityItemNotEligible: 1,
  claimsIneligibilityItemReturned: 1,
  claimsIneligibilityItemReturnedOrClaimed: 1,
  claimsIneligibilityItemPackageNotDeliveredTooLate: 1,
  claimsIneligibilityItemNoEligibleItems: 1,
  claimsIneligibilityBopisItemNotEligible: 1,
  claimsIneligibilityItemTooEarly: 1,
  claimsIneligibilityItemDeliveredTooEarly: 1,
  claimsIneligibilityItemTooLate: 1,
  claimsIneligibilityPackageNotDeliveredTooLate: 1,
  claimsIneligibilityNoMultiPackageClaimsItem: 1,
  claimsIneligibilityNoMultiPackageClaimsPackage: 1,
  claimsIneligibilityPackageBeingReturned: 1,
  claimsIneligibilityPackageItemNotListedAsEligible: 1,
  claimsIneligibilityPackageItemsClaimed: 1,
  claimsIneligibilityPackageItemsReturned: 1,
  claimsIneligibilityPackageItemsReturnedOrClaimed: 1,
  claimsIneligibilityPackageNoEligibleItems: 1,
  claimsIneligibilityPackageTooEarly: 1,
  claimsIneligibilityPackageDeliveredTooEarly: 1,
  claimsIneligibilityPackageTooLate: 1,
  claimsIneligibilityPackageBopisItemsNotEligible: 1,
  claimsInvalidAuthError: 1,
  claimsMerchantNotLiveHeader: 1,
  claimsMerchantNotLiveSupportButtonText: 1,
  claimsOrderClaimsCaseAlreadyHasClaims: 1,
  claimsOrderClaimsOrderNumberLabel: 1,
  claimsOrderClaimsOrderNumberLabelInput: 1,
  claimsOrderClaimsSetOrderNumber: 1,
  claimsOrderClaimsEditOrderNumber: 1,
  claimsOrderClaimsOverviewHeader: 1,
  claimsOrderClaimsStartClaimButton: 1,
  claimsOrderClaimsNoClaimsOnOrder: 1,
  claimsOrderClaimsOrderLabel: 1,
  claimsOrderClaimsListHeader: 1,
  claimsOrderClaimsListHeaderInCase: 1,
  claimsOrderClaimsListHeaderNotInCase: 1,
  claimsOrderClaimsListNoClaimsInCase: 1,
  claimsOrderClaimsLoading: 1,
  claimsOrderLookupApiErrorOrderNotFound: 1,
  claimsOrderLookupApiErrorUnknown: 1,
  claimsOrderLookupBottomContent: 1,
  claimsOrderLookupTitle: 1,
  claimsOrderLookupDescription: 1,
  claimsOrderLookupLoading: 1,
  claimsOrderLookupOrderNumberInputLabel: 1,
  claimsOrderLookupOrderNumberInputRequired: 1,
  claimsOrderLookupEmailInputLabel: 1,
  claimsOrderLookupEmailInputRequired: 1,
  claimsOrderLookupReasonDescription: 1,
  claimsOrderLookupReasonLabel: 1,
  claimsOrderLookupReasonRequired: 1,
  claimsOrderLookupReasonOptionMissingPackage: 1,
  claimsOrderLookupReasonOptionItemMissing: 1,
  claimsOrderLookupReasonOptionItemDamaged: 1,
  claimsOrderLookupReasonOptionWrongItem: 1,
  claimsOrderLookupReasonOptionWrongItemHelperText: 1,
  claimsOrderLookupReadOurPolicy: 1,
  claimsOrderLookupSubmit: 1,
  claimsOtpBack: 1,
  claimsOtpLast4Formatted: 1,
  claimsOtpSendCodeCoolMessage: 1,
  claimsOtpSendCode: 1,
  claimsOtpSendCodeError: 1,
  claimsOtpInvalidPhone: 1,
  claimsOtpInvalidCode: 1,
  claimsOtpUnableToReceiveCodePrompt: 1,
  claimsOtpUnableToReceiveCodeAction: 1,
  claimsOtpDidNotReceiveCodePrompt: 1,
  claimsOtpDidNotReceiveCodeAction: 1,
  claimsOtpDidNotReceiveCodeActionSuccess: 1,
  claimsOtpDidNotReceiveCodeActionError: 1,
  claimsOtpDisclaimer: 1,
  claimsOtpSendToNewPhoneTitle: 1,
  claimsOtpSendToNewPhoneDescription: 1,
  claimsOtpSendToNewPhoneInputPlaceholder: 1,
  claimsOtpSendToOrderPhoneTitle: 1,
  claimsOtpSendToOrderPhoneDescription: 1,
  claimsOtpSendToOrderPhoneUpdateNumberPrompt: 1,
  claimsOtpSendToOrderPhoneUpdateNumberAction: 1,
  claimsOtpSkipTitle: 1,
  claimsOtpSkipSubmit: 1,
  claimsOtpPhoneVerificationTitle: 1,
  claimsOtpPhoneVerificationCodeSent: 1,
  claimsOtpPhoneVerificationEnterCodeLabel: 1,
  claimsOtpPhoneVerificationEnterCodeSubmit: 1,
  claimsOtpPhoneVerificationUpdateNumberPrompt: 1,
  claimsOtpPhoneVerificationUpdateNumberAction: 1,
  claimsItemAttrLabelColor: 1,
  claimsItemAttrLabelPrice: 1,
  claimsItemAttrLabelQuantity: 1,
  claimsItemAttrLabelQuantityClaimed: 1,
  claimsItemAttrLabelEligibleQuantity: 1,
  claimsItemAttrLabelSize: 1,
  claimsItemAttrLabelSku: 1,
  claimsReasonLabel: 1,
  claimsReasonItemDamaged: 1,
  claimsReasonItemMissing: 1,
  claimsReasonWrongItem: 1,
  claimsReasonPackageMissing: 1,
  claimsRemoveItemTitle: 1,
  claimsRemoveItemTitleLine2: 1,
  claimsRemoveItemOptionYes: 1,
  claimsRemoveItemOptionNo: 1,
  claimsRemovePackageTitle: 1,
  claimsRemovePackageTitleLine2: 1,
  claimsRemovePackageOptionYes: 1,
  claimsRemovePackageOptionNo: 1,
  claimsSelectionRemoveSelection: 1,
  claimsSelectionIneligibleItem: 1,
  claimsSelectionIneligiblePackage: 1,
  claimsSelectionPackageItemsDisclosureHideItems: 1,
  claimsSelectionPackageItemsDisclosureShowItems: 1,
  claimsSelectionSelectableCardTagAdded: 1,
  claimsSelectionTitleItem: 1,
  claimsSelectionTitleItemItemsSelected: 1,
  claimsSelectionTitleItemNoEligibility: 1,
  claimsSelectionTitlePackage: 1,
  claimsSelectionTitlePackagePackagesSelected: 1,
  claimsSelectionTitlePackageNoEligibility: 1,
  claimsSelectionTitleLine2Item: 1,
  claimsSelectionTitleLine2ItemItemsSelected: 1,
  claimsSelectionTitleLine2ItemNoEligibility: 1,
  claimsSelectionTitleLine2Package: 1,
  claimsSelectionTitleLine2PackageNoEligibility: 1,
  claimsSelectionTitleLine2PackagePackagesSelected: 1,
  claimsShipmentEddLastDayDateFormat: 1,
  claimsShipmentEddLastWeekDateFormat: 1,
  claimsShipmentEddNextDayDateFormat: 1,
  claimsShipmentEddNextWeekDateFormat: 1,
  claimsShipmentEddSameDayDateFormat: 1,
  claimsShipmentEddSameElseDateFormat: 1,
  claimsShipmentItemsCount: 1,
  claimsShippingProtectionLabel: 1,
  claimsShippingProtectionPopoverDescription: 1,
  claimsShippingProtectionPopoverLabel: 1,
  claimsSummaryAppeasementRefundDescription: 1,
  claimsSummaryAppeasementRefundTitle: 1,
  claimsSummaryAppeasementReplacementDescription: 1,
  claimsSummaryAppeasementReplacementTitle: 1,
  claimsSummaryAppeasementTitle: 1,
  claimsSummaryClaimAmount: 1,
  claimsSummaryComment: 1,
  claimsSummaryClaimItemQuantityLabel: 1,
  claimsSummaryItemSubtitle: 1,
  claimsSummaryItemTitle: 1,
  claimsSummaryItemTitleLine2: 1,
  claimsSummaryPackageSubtitle: 1,
  claimsSummaryPackageTitle: 1,
  claimsSummaryPackageTitleLine2: 1,
  claimsSummarySignatureBullet0: 1,
  claimsSummarySignatureBullet1: 1,
  claimsSummarySignatureBullet2: 1,
  claimsSummarySignatureBullet3: 1,
  claimsSummarySignatureConfirmationCheckboxLabel: 1,
  claimsSummarySignatureInputHeading: 1,
  claimsSummarySignatureInputLabel: 1,
  claimsSummarySignatureSectionHeading: 1,
  claimsSummarySubmitApiError: 1,
  claimsSummarySubmitButtonDesktop: 1,
  claimsSummarySubmitButtonMobile: 1,
  claimsSummarySubmittingClaim: 1,
  claimsPhotoUploadTitleItemDamaged: 1,
  claimsPhotoUploadTitleItemMissing: 1,
  claimsPhotoUploadTitleWrongItem: 1,
  claimsPhotoUploadTitlePackageMissing: 1,
  claimsPhotoUploadDescription: 1,
  claimsPhotoUploadErrorFileType: 1,
  claimsPhotoUploadErrorSize: 1,
  claimsPhotoUploadButtonText: 1,
  claimsPhotoUploadRemoveButtonLabel: 1,
  claimsConfirmationTitle: 1,
  claimsConfirmationDescription: 1,
  claimsConfirmationDescriptionWrongItem: 1,
  claimsConfirmationDescriptionItemMissing: 1,
  claimsConfirmationDescriptionItemDamaged: 1,
  claimsConfirmationDescriptionPackageMissing: 1,
  claimsConfirmationButton: 1,
  claimsQuantityInputLabel: 1,
  claimsQuantityTitle: 1,
  claimsTagAddedItemMissing: 1,
  claimsTagAddedItemDamaged: 1,
  claimsTagAddedPackageMissing: 1,
  claimsTagAddedWrongItem: 1,
  claimsTagSelectedItemMissing: 1,
  claimsTagSelectedItemDamaged: 1,
  claimsTagSelectedPackageMissing: 1,
  claimsTagSelectedWrongItem: 1,
  claimsSupportPlatformCommunicationError: 1,
  trackLinkToClaimsPortal: 1,
  returnsCsrSignInError401: 1,
  returnsCsrSignInError500: 1,
  returnsCsrSignInTitle: 1,
  returnsCsrSignInDetails: 1,
  returnsCsrSignInOrderPlaceholder: 1,
  returnsCsrSignInPrimaryButton: 1,
  returnsPudoListTitle: 1,
  returnsPudoListItemhomepickupTitle: 1,
  returnsPudoListItemhomepickupSubtitle: 1,
  returnsPudoListItemstoreTitle: 1,
  returnsPudoListItemstoreSubtitle: 1,
  returnsPudoListItemstoreLinktext: 1,
  returnsPudoListItemconciergepartnershipTitle: 1,
  returnsPudoListItemconciergepartnershipSubtitle: 1,
  returnsPudoListItemprinterlessmailTitle: 1,
  returnsPudoListItemprinterlessmailSubtitle: 1,
  returnsPudoListItemmailTitle: 1,
  returnsPudoListItemmailSubtitle: 1,
  returnsPudoListItemmailLinktext: 1,
  returnsPudoListShowall: 1,
  returnsPudoListFeeLabellabelfee: 1,
  returnsPudoListFeeLabelshippingfee: 1,
  returnsPudoListFeeLabelpickupfee: 1,
  returnsPudoListFeeLabelFree: 1,
  returnsPudoLocationsPostalcodeTitle: 1,
  returnsPudoLocationsPostalcodeSearch: 1,
  returnsPudoLocationsPostalcodeCancel: 1,
  returnsPudoLocationsDistanceUnitmiles: 1,
  returnsPudoLocationsDistanceUnitkilometers: 1,
  returnsPudoLocationsDistanceNounit: 1,
  returnsPudoPickupTimeslotTitle: 1,
  returnsPudoPickupTimeslotDescription: 1,
  returnsPudoPickupLocationTitle: 1,
  returnsPudoPickupLocationDescription: 1,
  returnsPudoPickupInstructionsToggle: 1,
  returnsPudoPickupFeeTitle: 1,
  returnsPudoPickupFeeDescription: 1,
  returnsPudoPickupInstructionsPlaceholder: 1,
  returnsPudoPickupInstructionsHandoffTitle: 1,
  returnsPudoSubmit: 1,
  returnsPudoErrorNopudooptions: 1,
  returnsPudoErrorNotimeslots: 1,
  returnsOrderLoginTitle: 1,
  returnsOrderLoginDescription: 1,
  returnsOrderLoginFormSubmit: 1,
  returnsOrderLoginFormLabelEmail: 1,
  returnsOrderLoginFormLabelOrder: 1,
  returnsPudoLocationsSortedbyOptionRecommended: 1,
  returnsPudoLocationsSortedbyOptionDistance: 1,
  returnsPudoLocationsSortedbyTitle: 1,
  returnsReasonsItemInfoTitle: 1,
  returnsReasonsItemInfoColor: 1,
  returnsReasonsItemInfoColorLabel: 1,
  returnsReasonsItemInfoSize: 1,
  returnsReasonsItemInfoSizeLabel: 1,
  returnsReasonsItemInfoQuantity: 1,
  returnsReasonsItemInfoQuantityLabel: 1,
  returnsReasonsItemInfoQuantitySelectPlaceholder: 1,
  returnsReasonsListTitle: 1,
  returnsReasonsListTitleSecondary: 1,
  returnsReasonsQuantityTitle: 1,
  returnsReasonsQuantityAllTitle: 1,
  returnsReasonsQuantityAllTitleHipaa: 1,
  returnsReasonsQuantityAllYesLabel: 1,
  returnsReasonsQuantityAllNoLabel: 1,
  returnsReasonsQuantityAllError: 1,
  returnsReasonsCommentsTitle: 1,
  returnsReasonsCommentsPlaceholder: 1,
  returnsReasonsEditTitle: 1,
  returnsReasonsEditRemoveLabel: 1,
  returnsReasonsEditContinueLabel: 1,
  returnsConfirmationstoreActionsPanelHeader: 1,
  returnsConfirmationstoreActionsPanelTitle: 1,
  returnsConfirmationstoreActionsPanelTitleHipaa: 1,
  returnsConfirmationstoreActionsPanelMainButton: 1,
  returnsConfirmationstoreActionsPanelDescription: 1,
  returnsConfirmationstoreActionsPanelDescriptionHipaa: 1,
  returnsConfirmationstoreActionsPanelEmailButton: 1,
  returnsConfirmationstoreInstructionsPanelHeader: 1,
  returnsConfirmationstoreStep1Title: 1,
  returnsConfirmationstoreStep1Details: 1,
  returnsConfirmationstoreStep2Title: 1,
  returnsConfirmationstoreStep2Details: 1,
  returnsConfirmationstoreItemsPanelHeader: 1,
  returnsConfirmationmailActionsPanelHeader: 1,
  returnsConfirmationmailActionsPanelTitle: 1,
  returnsConfirmationmailActionsPanelTitleHipaa: 1,
  returnsConfirmationmailActionsPanelMainButton: 1,
  returnsConfirmationmailActionsPanelDescription: 1,
  returnsConfirmationmailActionsPanelDescriptionHipaa: 1,
  returnsConfirmationmailActionsPanelEmailButton: 1,
  returnsConfirmationmailInstructionsPanelHeader: 1,
  returnsConfirmationmailStep1Title: 1,
  returnsConfirmationmailStep2Title: 1,
  returnsConfirmationmailStep2Details: 1,
  returnsConfirmationmailStep3Title: 1,
  returnsConfirmationmailStep3Details: 1,
  returnsConfirmationmailItemsPanelHeader: 1,
  returnsConfirmationprinterlessMailActionsPanelHeader: 1,
  returnsConfirmationprinterlessMailActionsPanelTitle: 1,
  returnsConfirmationprinterlessMailActionsPanelTitleHipaa: 1,
  returnsConfirmationprinterlessMailActionsPanelDescription: 1,
  returnsConfirmationprinterlessMailActionsPanelDescriptionHipaa: 1,
  returnsConfirmationprinterlessMailActionsPanelEmailButton: 1,
  returnsConfirmationprinterlessMailLocationPanelHeader: 1,
  returnsConfirmationprinterlessMailInstructionsPanelHeader: 1,
  returnsConfirmationprinterlessMailStep1Title: 1,
  returnsConfirmationprinterlessMailStep1Details: 1,
  returnsConfirmationprinterlessMailStep2Title: 1,
  returnsConfirmationprinterlessMailStep2TitleHipaa: 1,
  returnsConfirmationprinterlessMailStep3Title: 1,
  returnsConfirmationprinterlessMailStep3Details: 1,
  returnsConfirmationprinterlessMailItemsPanelHeader: 1,
  returnsConfirmationprinterlessMailSecondaryActionsPanelTitle: 1,
  returnsConfirmationprinterlessMailSecondaryActionsPanelDescription: 1,
  returnsConfirmationprinterlessMailSecondaryActionsPanelMainButton: 1,
  returnsConfirmationconciergeActionsPanelHeader: 1,
  returnsConfirmationconciergeActionsPanelTitle: 1,
  returnsConfirmationconciergeActionsPanelTitleHipaa: 1,
  returnsConfirmationconciergeActionsPanelMainButton: 1,
  returnsConfirmationconciergeActionsPanelDescription: 1,
  returnsConfirmationconciergeActionsPanelEmailButton: 1,
  returnsConfirmationconciergeLocationPanelHeader: 1,
  returnsConfirmationconciergeInstructionsPanelHeader: 1,
  returnsConfirmationconciergeStep1Title: 1,
  returnsConfirmationconciergeStep2Title: 1,
  returnsConfirmationconciergeStep2Details: 1,
  returnsConfirmationconciergeStep3Title: 1,
  returnsConfirmationconciergeStep3Details: 1,
  returnsConfirmationconciergeItemsPanelHeader: 1,
  returnsMonikerfedexDisplayName: 1,
  returnsMonikerfedexLinkText: 1,
  returnsMonikerfedexLinkUrl: 1,
  returnsMonikerupsDisplayName: 1,
  returnsMonikerupsLinkText: 1,
  returnsMonikerupsLinkUrl: 1,
  returnsMonikeruspsDisplayName: 1,
  returnsItemListIneligibleTitle: 1,
  returnsItemListReturnInitiatedTitle: 1,
  returnsItemListTitleDirty: 1,
  returnsItemListTitleDirtyHipaa: 1,
  returnsItemListTitle: 1,
  returnsItemListTitleHipaa: 1,
  returnsItemListEligibleDescription: 1,
  returnsItemListPendingDescription: 1,
  returnsItemListIneligibleDescription: 1,
  returnsItemListSubmit: 1,
  returnsItemListItemInfoTitle: 1,
  returnsItemListItemInfocolorLabel: 1,
  returnsItemListItemInfoskuLabel: 1,
  returnsItemListItemInfoqtyLabel: 1,
  returnsItemListItemInfoqtyTransactionSeparator: 1,
  returnsItemListItemInfopriceLabel: 1,
  returnsItemListItemInforeasonLabel: 1,
  returnsItemListItemTagReturning: 1,
  returnsItemListItemTagExchanging: 1,
  returnsReviewHeader: 1,
  returnsReviewHeaderCopy: 1,
  returnsReviewSubHeader: 1,
  returnsReviewItemCardSize: 1,
  returnsReviewItemCardQuantity: 1,
  returnsReviewTotalsSubtotal: 1,
  returnsReviewTotalsShippingFee: 1,
  returnsReviewTotalsEstimatedRefund: 1,
  returnsReviewTotalsHelpText: 1,
  returnsReviewSubmittingReturn: 1,
  returnsActionsNext: 1,
  returnsActionsBack: 1,
  returnsActionsBackToLogin: 1,
  returnsActionsCancel: 1,
  returnsActionsSubmit: 1,
  returnsItemListItemInfosizeLabel: 1,
  returnsOrderLoginFormValidationErrorEmail: 1,
  returnsItemListPendingCancelReturnLink: 1,
  returnsItemListBannererror: 1,
  returnsItemListBannersuccess: 1,
  returnsItemListPendingpackingSlipLink: 1,
  returnsItemListPendingshippingLabelLink: 1,
  returnsOrderLoginAbove: 1,
  returnsOrderLoginBelow: 1,
  returnsOrderLoginFormAbove: 1,
  returnsOrderLoginFormBelow: 1,
  returnsOrderLoginSubmitAbove: 1,
  returnsOrderLoginSubmitBelow: 1,
  returnsOrderLoginTitleBelow: 1,
  returnsOrderLoginFieldsAbove: 1,
  returnsConfirmationError: 1,
  returnsReasonsTypeTitle: 1,
  returnsReasonsTypeReturn: 1,
  returnsReasonsTypeExchange: 1,
  returnsReasonsExchangeTitle: 1,
  returnsReasonsExchangeUpsellTitle: 1,
  returnsReasonsExchangeUpsellNoThanks: 1,
  returnsReviewPolicyCheckbox: 1,
  returnsReviewDescriptionmail: 1,
  returnsReviewDescriptionconcierge: 1,
  returnsReviewDescriptionprinterlessMail: 1,
  returnsReviewDescriptionstore: 1,
  returnsReviewDescriptionself: 1
};
function proxyRetailerTranslations(translations, requestedTranslationKeys) {
  return new Proxy(translations, {
    get(target, property) {
      if (typeof property === 'string' && Object.prototype.hasOwnProperty.call(translationKeys, property) && !requestedTranslationKeys.includes(property)) {
        throw new Error(`translation key was not requested: ${property}`);
      }
      return Reflect.get(target, property);
    }
  });
}

exports["default"] = proxyRetailerTranslations;
